import { useT } from "../../../utilities/TranslatedText";
import { useEffect } from "react";
import BlockScroller from "../BlockScroller";
import BlockHead from "../_BlockHead";
import ClickableLink from "../../../utilities/ClickableLink";
import { observer } from "mobx-react";
import { ISharedFilesBlockProps } from "./SharedFilesBlock";
import ImageComponent from "../../../utilities/ImageComponent";

const FileBlock = observer((props: ISharedFilesBlockProps) => {
  const t = useT();
  useEffect(() => {
    const block = document.getElementById(props.htmlId);
    const blockHead = document.querySelector(
      `#${props.htmlId} .sb-blockHead`,
    ) as HTMLElement | null;
    const iframe = document.querySelector(
      `#${props.htmlId} #shared-file-iframe-${props.blockObj.id}`,
    ) as HTMLElement | null;

    const blockOuterHeight = block?.offsetHeight;
    const blockHeadOuterHeight = blockHead?.offsetHeight;
    if (iframe) {
      if (blockHeadOuterHeight === null) {
        iframe.style.height = String(blockOuterHeight);
      } else if (blockOuterHeight && blockHeadOuterHeight) {
        iframe.style.height = String(blockOuterHeight - blockHeadOuterHeight);
      }
    }
  }, []);

  const previewTitle =
    props.blockObj.file?.title?.trim() ||
    props.blockObj.blockModel.title?.trim() ||
    t("File preview");

  let component;
  let headerIcon;
  switch (props.blockObj.fileType) {
    case "video":
      component = <video src={props.blockObj.url} controls />;
      break;
    case "audio":
      component = <audio src={props.blockObj.url} controls />;
      break;
    case "image":
      component = <ImageComponent src={props.blockObj.url ?? ""} />;
      break;
    case "googledocs":
      component = (
        <iframe
          title={previewTitle}
          src={`https://docs.google.com/viewer?srcid=${props.blockObj.gFileId}&pid=explorer&efh=false&a=v&chrome=false&embedded=true`}
          id={`shared-file-iframe-${props.blockObj.id}`}
          frameBorder="no"
        ></iframe>
      );
      headerIcon = (
        <div
          className="fab fa-fw fa-google"
          aria-hidden="true"
          style={{
            color: "inherit",
            display: "inline-block",
            fontSize: "1.4em",
            marginRight: "0.3em",
          }}
        />
      );
      break;
    default:
      component = (
        <iframe
          title={previewTitle}
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(props.blockObj.url as string)}&embedded=true`}
          id={`shared-file-iframe-${props.blockObj.id}`}
          frameBorder="no"
        ></iframe>
      );
  }
  const title = props.blockObj.blockModel.title
    ? props.blockObj.blockModel.title
    : "Shared Files";

  return (
    <BlockScroller
      blockRef={props.blockRef}
      blockObj={props.blockObj}
      setShowExpandButton={props.setShowExpandButton}
      outsideGrid={props.outsideGrid}
    >
      <BlockHead
        blockType={props.blockObj.blockType}
        editableTitle={title}
        blockId={props.blockObj.id}
        isBlockPreview={props.isBlockPreview}
      >
        <ClickableLink
          href={props.blockObj?.file?.viewLink || props.blockObj.url}
          style={{ position: "static" }}
          title={"View " + props.blockObj?.file?.type || "file"}
        >
          {headerIcon}
        </ClickableLink>
      </BlockHead>
      <div
        className="sb-blockContent sb-organization-color-element-font"
        style={{ padding: 0 }}
      >
        {component}
      </div>
    </BlockScroller>
  );
});

export default FileBlock;
